import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import "../CSS/Template.css"
import Checkbox from '../Components/Checkbox.js';
import AppointmentService from '../utils/AppointmentService.js';
import AddCCForm from '../Components/AddCCForm.js';
import Select from 'react-select';
import TextField from '@material-ui/core/TextField';
import Modal from 'react-modal';
import InfiniteCalendar from 'react-infinite-calendar';
import moment from 'moment'
import ErrorSnackBar from '../Components/ErrorSnackBar.js';
import Cards from '../images/creditcards.png';
import Vehicles from '../images/vehiclesicon.png';
import Locations from '../images/locationsicon.png';
//import 'moment-timezone';
import 'react-infinite-calendar/styles.css';
import { ClipLoader } from 'react-spinners';
import { css } from 'react-emotion';
import {
  BrowserRouter as Router,
  Link,
  Route // for later
} from 'react-router-dom'
// if (!window.Promise) {
//   window.Promise = Promise;
// }

const override = css`
    display: block;
    margin: 10% 45%;
    border-color: red;
`;

//import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'

export class UserProfile extends Component {
  constructor(props) {
    super(props)
    var id = props.match.params.image_id
    this.state = {
      firstName: '',
      lastName: '',
      email:'',
      phone:'',
      password: '',
      passwordConfirm: '',
      partnerCode: '',
      formError: '',
      accoutBalance: 0,
      open: false,
      color: '',
      errorMessage: '',
      giftcardCode: '',
      redeemModalOpen: false,
      loading: false,
      width: document.body.clientWidth
    }
    this.ApptService = new AppointmentService()
    this.saveProfile = this.saveProfile.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)
  }
  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
    this.ApptService.getUser()
    .then(res =>{
      if(res && !res.email.includes("@genericuser.getspiffy.com")){
        this.setState({
          firstName: res.first_name,
          lastName: res.last_name,
          email: res.email,
          phone: res.phone,
          partnerCode: res.partner_code,
          accountBalance: res.account_balance
        })
      }
      else{
      }
    })
  }
  componentWillUnmount() {
      window.removeEventListener("resize", this.updateDimensions);
  }
  updateDimensions() {
      this.setState({width: document.body.clientWidth});
  }

  handleChange = name => event => {
    var value = event.target.value
    value = value.replace(/(\d{3})\-?(\d{3})\-?(\d{4})/,'$1-$2-$3')
     this.setState({
       [name]: value,
     },function () {
        this.validatePhone()
     });
  };
  validatePhone() {
    if(this.state.phone && (this.state.phone.length != 10 && this.state.phone.length != 12)){
      this.setState({
        open: false,
        phoneError: true
      })
    }
    else {
      this.setState({
        open: false,
        phoneError: false
      })
      return true
    }
  }
  openModal() {
    this.setState({modalIsOpen: true});
  }
  closeModal() {
    this.setState({modalIsOpen: false});
  }
  saveProfile () {
    if(this.state.password == this.state.passwordConfirm){
      this.setState({
        loading:true
      })
      this.ApptService.updateUser(this.state.firstName, this.state.lastName, this.state.email, this.state.phone, this.state.password, this.state.partnerCode)
      .then(res => {
        this.setState({
          errorMessage: 'Profile has been updated',
          open: true,
          color: 'green',
          loading: false
        })
      })
      .catch(err => {
        throw new Error("Cannot save Profile" + err)
        this.setState({
          errorMessage: 'Profile cannot be updated',
          open: true,
          color: '#c42d2d',
          loading:false
        })
      })
    }
    else {
      this.setState({
        errorMessage: 'Passwords must match',
        color: '#c42d2d',
        open: true
      })
    }
  }
  redeemGiftcard() {
    this.setState({
      loading:true
    })
    this.ApptService.redeemGiftcard(this.state.giftcardCode)
    .then(res => {
      if(res.errors){
        this.setState({
          open: true,
          color: '#A43E42',
          errorMessage: res.errors,
          redeemModalOpen: false,
          loading: false
        })
      }
      else if(res){
        this.setState({
          open: true,
          color: '#5FB978',
          errorMessage: "Your giftcard has been applied. Your account balance is $" + res.account_balance/100.0,
          redeemModalOpen: false,
          accountBalance: res.account_balance,
          loading:false
        })
      }
    })
    .catch(error => {
      throw new Error('Error redeeming giftcard' + error.message);
      this.setState({
        loading:false
      })
    })
  }
  validateFields() {
    if (!this.validatePhone()){
      this.setState({
        open: true,
        color: '#c42d2d',
        errorMessage: 'Phone Number is invalid'
      })
      return false
    }
    if(!this.state.amount || this.state.amount < 0 || isNaN(this.state.amount)){
      this.setState({
        open: true,
        color: '#c42d2d',
        errorMessage: 'Amount is required and must be a valid'
      })
      return false
    }
    if(!this.state.name){
      this.setState({
        open: true,
        color: '#c42d2d',
        errorMessage: 'Recipient Name is required'
      })
      return false
    }
    if(!this.state.email){
      this.setState({
        open: true,
        color: '#c42d2d',
        errorMessage: 'Recipient Email is required and must be valid'
      })
      return false
    }
    if(!this.state.creditCard){
      this.setState({
        open: true,
        color: '#c42d2d',
        errorMessage: 'Credit card must be selected'
      })
      return false
    }
    else {
      return true
    }
  }
  selectDate = (date) => {
      var sendAt = new Date(date)
      var sendAtDate = moment(sendAt).format('MMMM Do YYYY')
      this.setState({
        sendAt: sendAt,
        sendAtFormatted: sendAtDate,
        shrink:true,
        modalIsOpen: false,
      })
  }
  render() {
    const { textmask, numberformat } = this.state;
    const { classes } = this.props;
    var ccValue = null
    if (this.state.creditCard){
      ccValue = this.state.creditCard.value
    }
    const newCCStyles =
    this.state.width < 780 ?
    {
      content: {
        width: '98%',
        left:'1%',
        padding: '0px !important'
      }
    }:
      {
        content: {
          width: '50%',
          left:'25%',
          height: '65%',
          padding: '0px !important'
        }
      }
    const customStyles =
      this.state.width < 780 ?
      {
        content: {
          top                   : '25%',
          width                 : '98%',
          left                  : '1%',
          right                 : 'auto',
          bottom                : 'auto',
        }
      }:
        {
          content: {
            top                   : '50%',
            left                  : '50%',
            right                 : 'auto',
            bottom                : 'auto',
            transform             : 'translate(-50%, -50%)'
          }
        }
        const modalStyle =
          this.state.width < 780 ?
            {
              content: {
                top                   : '17%',
                left                  : '0%',
                height                : '65%',
                width                 : '100%',
                padding               : '0px',
                right                 : 'auto',
                backgroundColor       : '#253D59',
                color                 : 'white',
              }
            }:
            {
              content: {
                top                   : '17%',
                left                  : '27%',
                height                : '65%',
                width                 : '45%',
                padding               : '0px',
                right                 : 'auto',
                backgroundColor       : '#253D59',
                color                 : 'white',
              }
            }
    return (
      <div>
      <div className="card-header blue-background text-white text-center dateTimeContainer ">
        <h4>My Profile</h4>
      </div>
        <div className="whiteBackground">
          <p className="errorMessage">{this.state.formError}</p>
          <div className="twoColumn">
            <div className="halfWidth">
              <TextField
                id="email"
                value={this.state.email}
                label="Email"
                onChange={this.handleChange('email')}
                margin="dense"
                fullWidth
               />
              </div>
                <div className="halfWidth">
                  <TextField
                    id="phone"
                    value={this.state.phone}
                    label="Phone"
                    onChange={this.handleChange('phone')}
                    margin="dense"
                    fullWidth
                   />
                </div>
           </div>
          <div className="twoColumn">
            <div className="halfWidth">
             <TextField
               id="firstName"
               value={this.state.firstName}
               label="First Name"
               onChange={this.handleChange('firstName')}
               margin="dense"
               fullWidth
              />
              </div>
              <div className="halfWidth">
                <TextField
                  id="lastName"
                  value={this.state.lastName}
                  label="Last Name"
                  onChange={this.handleChange('lastName')}
                  margin="dense"
                  fullWidth
                 />
              </div>
            </div>
            <div className="twoColumn">
              <div className="halfWidth">
               <TextField
                 id="password"
                 value={this.state.password}
                 label="Password"
                 type="password"
                 onChange={this.handleChange('password')}
                 margin="dense"
                 fullWidth
                />
                </div>
                <div className="halfWidth">
                  <TextField
                    id="passwordConfirm"
                    type="password"
                    value={this.state.passwordConfirm}
                    label="Confirm Password"
                    onChange={this.handleChange('passwordConfirm')}
                    margin="dense"
                    fullWidth
                   />
                </div>
              </div>
              <div className="twoColumn">
                <div className="halfWidth">
                  <TextField
                      id="partner_code"
                      value={this.state.partnerCode}
                      label="Partner Code (Optional)"
                      onChange={this.handleChange('partnerCode')}
                      margin="dense"
                      fullWidth
                  />
                </div>
              </div>
              <br></br>
              <button className="ccFormElement btn btn-success btn-block text-center" onClick = {() => this.saveProfile()}>Save Profile</button>
              <br></br>
              <hr></hr>
              <br></br>
              <div className="flex-container">
                <a href="../credit-cards">
                  <div>
                    <img className="list-icon profileIcons" src={Cards}></img>
                    <p>My Cards</p>
                  </div>
                </a>
                <a href="../vehicles">
                  <div>
                    <img className="list-icon profileIcons" src={Vehicles}></img>
                    <p>My Vehicles</p>
                  </div>
                </a>
                <a href="../locations">
                  <div>
                    <img className="list-icon profileIcons" src={Locations}></img>
                    <p>My Locations</p>
                  </div>
                </a>
              </div>
              <br></br>
              <p>Account Balance: ${this.state.accountBalance/100.0}</p>
              <button className="ccFormElement btn btn-success btn-block text-center" onClick = {() => this.setState({redeemModalOpen: true})}>Redeem Giftcard</button>
        </div>
        {(this.state.errorMessage && this.state.errorMessage.length) &&
          <ErrorSnackBar color = {this.state.color} open={this.state.open} message = {this.state.errorMessage}/>
        }
        <Modal
          isOpen={this.state.redeemModalOpen}
          contentLabel="Example Modal"
          style={customStyles}
          >
          <div>
            <div className="card-header blue-background text-white text-center dateTimeContainer ">
              <h4>Redeem EGiftcard</h4>
            </div>
            <br></br>
            <h6>If you have a valid eGift Card, we will apply it to your available account balance</h6>
            <input value={this.state.giftcardCode} onChange={this.handleChange('giftcardCode')} className="promoInput"></input>
            <button className="btn btn-primary promoAdd" onClick={() =>this.redeemGiftcard()}>Submit</button>
            <button onClick = {() => this.setState({redeemModalOpen: false})}className="btn btn-block cancelButton2 text-center">Cancel</button>
            <h6 id="promoErrorSummary">{this.state.promoError}</h6>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.loading}
          contentLabel="Example Modal"
          style={newCCStyles}
          >
          <div className="card-header blue-background text-white text-center dateTimeContainer ">
            <h4>Loading</h4>
          </div>
          <div className="topDiv">
            <ClipLoader
              className={override}
              sizeUnit={"px"}
              size={100}
              color={'#164070'}
              loading={this.state.loading}
            />
          </div>
        </Modal>
      </div>
    )
}
}
export default UserProfile



// WEBPACK FOOTER //
// ./src/Components/UserProfile.js